import type { CSSProperties, ReactNode } from 'react';
import { DividerContainer } from './styles';

const Divider = ({ children, style }: { children: ReactNode; style?: CSSProperties | undefined }) => {
  return <DividerContainer style={style}>{children}</DividerContainer>;
};

export default Divider;
